export default __webpack_public_path__ + "static/media/business-premium.4b682d5c46a850fc85a127f7a22cc172.4b682d5c.svg";